import React, { useRef } from 'react'

function RegistrarRow({ title, styles, checkoutUrl, selectedDomain }) {
  const linkRef = useRef(null)
  const handleRowClick = (e) => {
    // Only send event if target is the link, otherwise pass click through to the link (which will trigger this again)
    if (e.target.nodeName === 'A') {
      // Send explicit GTM event
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'registrar_select',
        domain: selectedDomain,
        registrar: title,
      })
    } else {
      linkRef.current.click()
    }
  }
  return (
    <li className='registrar-row' style={styles} onClick={handleRowClick}>
      {title && <p className='registrar-row__title'>{title}</p>}
      {checkoutUrl && (
        <a
          href={checkoutUrl}
          target='_blank'
          className='registrar-row__button button c-btn c-btn--small'
          data-gtm-referral={title}
          aria-label={`Select ` + title}
          ref={linkRef}
        >
          Select
        </a>
      )}
    </li>
  )
}

export default RegistrarRow
